<template>
    <div id="confirm-box" class="popup">
        <div class="confirm-body fixed-box s-content">
            <div class="content">
                <div class="img"></div>
                <p v-html='($root.confirm[0]&&$root.confirm[0].text)||last.text||"您确定要进行此操作？"'></p>
            </div>
            <div class="bts">
                <button class="no" @click="cancel">否</button>
                <button class="yes" @click="confirm">是</button>
            </div>
        </div>
    </div>
</template>
<style lang="less">
    #confirm-box .confirm-body {
        padding: 0;
        position: relative;
        width: 400px;
        border-top: 4px solid #4484f3;


        .img {
            background-color: #f3b344;
            background-image: url(../assets/images/confirm_icon.png);
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 30px;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-size: 55%;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 20px;
            box-shadow: 5px 5px 10px rgba(243, 179, 68, 0.3);
            flex-shrink: 0;
        }
    }

    #confirm-box .content {
        display: flex;
        align-items: center;
        color: #5f5f5f;
        font-size: 16px;
        padding: 30px 50px;
    }

    #confirm-box .content img {
        margin-right: 18px;
    }

    #confirm-box .content p {
        margin: 0;
        font-size: 18px;
    }

    #confirm-box .bts {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #confirm-box .bts button {
        width: 50%;
        height: 50px;
        background-color: white;
        font-size: 16px;
        transition: all .1s;
        border-radius: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 26px;
        font-size: 20px;
    }

    #confirm-box .bts button:hover {
        opacity: .7;
    }

    #confirm-box .bts .yes {
        background-color: #4484f3;
        border: none;
        color: white;
        // background-image: url(../assets/images/confirm_yes.png);
    }

    #confirm-box .bts .no {
        border: none;
        color: #4484f3;
        // background-image: url(../assets/images/confirm_no.png);
    }

    #confirm-box .close {
        width: 22px;
        height: 22px;
        background-image: url(../assets/images/alert_close.png);
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        right: 32px;
        top: 22px;
        background-color: white;
        border: none;
        transition: all .2s;
    }

    #confirm-box .close:hover {
        opacity: .7;
    }
</style>
<script>
    // 示例：
    // this.$root.confirm.push({
    //     text: "确定通过该订单审核？",
    //     fn: function () {
    //         console.log(1);
    //     }
    // });
    export default {
        data: function () {
            return {
                last: {}
            }
        },
        methods: {
            confirm: function () {
                this.$root.confirm[0].fn(this.$root.confirm[0].arg);
                this.last = this.$root.confirm.shift();
            },
            cancel: function () {
                this.last = this.$root.confirm.shift();
            }
        }
    }
</script>